<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5"></a>FOR MY PARENTS<br/>ANN TRUITT KARRENBROCK AND<br/>JACK WOMACK, SR.</p>
<p class="noindent"><a id="page_6"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3b0d3fbd